import React from 'react';
// We don't need to import CSS here if it's in App.css, 
// but the component structure needs to match the CSS classes.

const Tooltip = ({ text }) => (
  <div className="tooltip-container" style={{marginLeft: '8px', display: 'inline-flex', alignItems: 'center'}}>
    {/* The 'i' Icon */}
    <div className="info-icon" style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '18px',
        height: '18px',
        borderRadius: '50%',
        backgroundColor: '#ebecf0',
        color: '#5e6c84',
        fontSize: '12px',
        fontWeight: 'bold',
        cursor: 'help',
        border: '1px solid #dfe1e6'
    }}>
        i
    </div>
    
    {/* The Hover Text (Controlled by CSS) */}
    <span className="tooltip-text">{text}</span>
  </div>
);

export default Tooltip;